import React, { useState, useEffect } from 'react'
import useBreadcrumbs from 'use-react-router-breadcrumbs'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'

import { hubRoutes } from 'routes/hub'
import { semanthicPathsBreadcrumbIgnore } from './constants'
import { BreadcrumbUI } from './UI'
import { filterBreadcrumbs } from './behavior'

export interface IRouteProps {
  path: string
  name: string
}

export const Breadcrumb = (): JSX.Element => {
  const navigate = useNavigate()
  const breadcrumbs = useBreadcrumbs(hubRoutes, { excludePaths: semanthicPathsBreadcrumbIgnore })
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    const handleTrackNameChange = () => {
      setRefreshKey(prev => prev + 1)
    }

    window.addEventListener('trackNameChanged', handleTrackNameChange)
    return () => window.removeEventListener('trackNameChanged', handleTrackNameChange)
  }, [])

  const filteredBreadcrumbs = filterBreadcrumbs(breadcrumbs)

  return (
    <>
      <BreadcrumbUI key={refreshKey} filteredBreadcrumbs={filteredBreadcrumbs} navigate={navigate} />
    </>
  )
}
